import axios from './index'

class menu {
    //获取菜单列表
    static menuList(params) {
        return axios.get(`app-admin/v1/manager/b2b/supplier/menu/menu-tree-list`, { params: params })
    }
    static roleList(params) {
        return axios.get('app-admin/v1/manager/b2b/supplier/role/list', { params: params })
    }
    static addRole(params) {
        return axios.post('app-admin/v1/manager/b2b/supplier/role/insert', params)
    }
    //验证角色唯一性
    static onlyUser(params) {
        return axios.get('app-admin/v1/manager/b2b/supplier/role/check-role-name-unique', { params: params })
    }
    //新建菜单
    static menuInsert(params) {
        return axios.post('app-admin/v1/manager/b2b/supplier/menu/insert', params)
    }
    static menuUpdate(params) {
        return axios.post('app-admin/v1/manager/b2b/supplier/menu/update', params)
    }
}

export default menu;
